import React, { Component } from "react";
import IdleTimer from "react-idle-timer";
// import format from "date-fns/format";

import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
// import _ from "lodash";
import jwt_decode from "jwt-decode";
import setAuthToken from "./utils/setAuthToken";
import {
  setCurrentUser,
  loginUser,
  logoutUser,
  dataFromSign
} from "./redux/actions/authActions";
import { receiveDataFromDirectories } from "./redux/actions/getSelectData";
import { setApplicant, mainActionID } from "./redux/actions/applicantAction";
import { setAgrimant, setPaymant } from "./redux/actions/agrimantActions";
import {
  applicationIDAction,
  applicationAction,
  setApplicationFlags
} from "./redux/actions/applicationAction";
import {
  receiveChildrenTable,
  getChildrenSelectArray
} from "./redux/actions/children";
import { Provider } from "react-redux";
import store from "./store";

import { history } from "./utils/hist";
import PrivateRoute from "./PrivateRoute";

import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

import "./assets/scss/material-kit-react.scss?v=1.4.0";
import "./App.css";

// pages for this product
import LandingPage from "./views/LandingPage/LandingPage.jsx";
import ProfilePage from "./views/ProfilePage/ProfilePage.jsx";
import Paymants from "./views/ProfilePage/Paymants.jsx";
import LoginPage from "./views/LoginPage/LoginPage.jsx";
import isEmpty from "./validation/is-empty";
import Component404 from "./views/Component404.jsx";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { isIdleAction } from "redux/actions/isIdleAction.js";

import ReactGA from 'react-ga';
ReactGA.initialize('UA-165449852-1');
ReactGA.pageview(window.location.pathname + window.location.search);
const MySwal = withReactContent(Swal);
// Check for token
if (localStorage.jwtToken) {
  // Set auth token header auth
  //console.log(localStorage.jwtToken)
  setAuthToken(localStorage.jwtToken);
  // Decode token and get user info and exp
  const decoded = jwt_decode(localStorage.jwtToken);
  const userInfo = JSON.parse(decoded.sub);
 
  // Set user and isAuthenticated
  if (!isEmpty(userInfo)) {
    const applicant = {
      name: userInfo.givenname,
      surname: userInfo.lastname,
      fathername: userInfo.middlename,
      rnokpp: userInfo.drfocode
    };
    store.dispatch(setCurrentUser(applicant));
  }

  if (!isEmpty(localStorage.id)) {
    const id = localStorage.id;
    store.dispatch(applicationIDAction(JSON.parse(id)));
  }

  if (!isEmpty(localStorage.aplication)) {
    const application = localStorage.aplication;
    store.dispatch(applicationAction(JSON.parse(application)));
  }
  if (!isEmpty(localStorage.f)) {
    const flags = localStorage.f;
    store.dispatch(setApplicationFlags(JSON.parse(flags)));
  }
  if (!isEmpty(localStorage.agreemant)) {
    const agreemant = JSON.parse(localStorage.agreemant);
    store.dispatch(setAgrimant(agreemant));
  }
  if (!isEmpty(localStorage.childrenList)) {
    const childrenList = JSON.parse(localStorage.childrenList);
    store.dispatch(receiveChildrenTable(childrenList));
  }

  if (!isEmpty(localStorage.childrenSelect)) {
    const childrenSelect = JSON.parse(localStorage.childrenSelect);
    store.dispatch(getChildrenSelectArray(childrenSelect));
  }

  if (!isEmpty(localStorage.paymant)) {
    const paymant = JSON.parse(localStorage.paymant);
    store.dispatch(setPaymant(paymant));
  }

  if (!isEmpty(localStorage.catalog)) {
    const catalogs = JSON.parse(localStorage.catalog);
    store.dispatch(receiveDataFromDirectories(catalogs));
  }

  if (!isEmpty(localStorage.applicant)) {
    const applicant = JSON.parse(localStorage.applicant);
    store.dispatch(dataFromSign(applicant));
  }
  // //appliacantList
  if (!isEmpty(localStorage.applicantList)) {
    const applicantList = JSON.parse(localStorage.applicantList);
    store.dispatch(setApplicant(applicantList));
  }
  if (!isEmpty(localStorage.ID)) {
    store.dispatch(mainActionID(JSON.parse(localStorage.ID)));
  }

  //  store.dispatch(setApplicant(JSON.parse(localStorage.issuer)))
  // Check for expired token
  const currentTime = Date.now() / 1000;
  // console.log(decoded.exp < currentTime)
  if (decoded.exp < currentTime) {
    history.push("/login");
    // MySwal.fire({
    //   title: "Час сесії закінчився",
    //   //text: "Your session has expired. Would you like to be redirected to the login page?",
    //   //type: "warning",
    //   //showCancelButton: true,
    //   confirmButtonColor: "#2D5CA6",
    //   confirmButtonText: "Ok",
    //   closeOnConfirm: false
    // }).then(result => {
    //     // Logout user
    //     if (result.value) {
    //       store.dispatch(logoutUser());
    //       // Redirect to login
    //       //window.location.href = '/login';
    //       history.push("/login");
    //     }
     
    // });
  }
}

var hist = createBrowserHistory();
// store.subscribe(()=>{
//     //saveState(store.getState())
//     // console.log(store.getState().auth.isAuthenticated)
//     if (store.getState().auth.isAuthenticated) {
//       if (store.getState().isEdle) {
//       //   MySwal.fire({
//       //     title: "Час сесії закінчився",
//       //     //text: "Your session has expired. Would you like to be redirected to the login page?",
//       //     //type: "warning",
//       //     //showCancelButton: true,
//       //     confirmButtonColor: "#2D5CA6",
//       //     confirmButtonText: "Ok",
//       //     closeOnConfirm: false
//       // }).then(result => {
//       //   store.dispatch(isIdleAction(false))
//       //   history.push("/login");
//       // })
//       }
//   }
// })

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      "proba_pro_regular",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    useNextVariants: true
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 700,
      md: 1100,
      lg: 1500,
      xl: 1920
    }
  },
  palette: {
    primary: {
      main: "#2D5CA6"
    },
    secondary: {
      main: "#79ac3d"
    }
  },
  overrides: {
    MuiModal: {
      root: {
        zIndex: "1300 !important"
      }
    },
    MuiButton: {
      root: {
        borderRadius: "0px"
      }
    }
  },

});


class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <MuiThemeProvider theme={theme}>
 
          <Router history={history}>
            <Switch>
              <Route exact path="/" component={LandingPage} />
              <Route exact path="/login" component={LoginPage} />
              {/* </Switch> */}
              {/* <Switch> */}
              <PrivateRoute
                // exact
                path="/profile-page"
                component={ProfilePage}
              />
              {/* <Route exact path="/profile-page" component={ProfilePage} /> */}
              {/* </Switch>
          <Switch> */}
              <PrivateRoute exact path="/paymants/:id" component={Paymants} />
              {/* <PrivateRoute exact path="/agreements/:id" component={Agreements} /> */}
              <Route path="*" component={Component404} />
            </Switch>
            {/* <Switch> */}

            {/* </Switch> */}
          </Router>
        </MuiThemeProvider>
      </Provider>
    );
  }
}

export default App;
